import { Vue, Watch, Prop } from 'vue-property-decorator'
import { Page } from '@/models/Page'
import { Pages } from '@/models/Pages'

export default class PageBase extends Vue {

	get pages() {
		return this.$store.getters.pages
	}

	get pagesParentValues() {
		const values = this.pages.models.map((page) => ({ key: page.id, value: page.name }))
		values.unshift({ key: 0, value: '(Top)' })
		return values
	}

	protected pageParentStringValue(id: number) {
		const selected = this.pagesParentValues.find((el: any) => el.key === id)
		if (selected) {
			return selected.value
		}
		return ''
	}
}
